import { render, staticRenderFns } from "./balance_detailsprint.vue?vue&type=template&id=89972a28&scoped=true&"
import script from "./balance_detailsprint.vue?vue&type=script&lang=js&"
export * from "./balance_detailsprint.vue?vue&type=script&lang=js&"
import style0 from "./balance_detailsprint.vue?vue&type=style&index=0&id=89972a28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89972a28",
  null
  
)

export default component.exports